const translations = {
    batterySerialNumberFieldLabel: 'Battery Serial Number'
};

export default translations;
